export default __webpack_public_path__ + "static/media/run.64f9aebb.svg";